import { makeStyles } from "@material-ui/core/styles";
import {
    DeleteForever,
    Edit as EditIcon,
    PictureAsPdf,
    WarningOutlined
} from "@material-ui/icons";

import React, { useContext, useEffect, useState } from "react";

import { Paper, Snackbar } from "@material-ui/core";
import { CircularProgress, Tooltip } from "@mui/material";
import axios from "axios";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import SweetAlert from "react-bootstrap-sweetalert";

import { configUrl } from "config.js";
import { LoginContext } from "contexts/LoginContext";
import { TestContext } from "contexts/TestContext";

import SpellcheckIcon from '@material-ui/icons/Spellcheck';
import { Alert } from "@material-ui/lab";
import CustomModal from "components/CustomModal/CustomModal";
import useGetCategories from "hooks/categoryHooks/useGetCategories";
import useDeletePool from "hooks/poolHooks/useDeletePool";
import useGetPoolsByTest from "hooks/poolHooks/useGetPoolsByTest";
import useDecreasePoolSequence from "hooks/testsHooks/useDecreasePoolSequence";
import useIncreasePoolSequence from "hooks/testsHooks/useIncreasePoolSequence";
import TestPlayer from "views/Components/PDFBasedTestComponents/TestPlayer";
import PdfTestPoolForm from "../PoolForms/PdfTestPoolForm";

const useStyles = makeStyles({
    cardHeader: {
        backgroundColor: "black",
        borderRadius: 10,
        color: "white",
        padding: "10px 20px",
    },
    fileMeta: {
        marginTop: 6,
        fontSize: 12,
        color: "#ddd",
    },
    smallText: {
        fontSize: 12,
        color: "#fff",
        display: "block",
    },
    iconLabel: {
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        marginLeft: 8,
    },
});

const TestPdfSectionMapping = React.forwardRef((props, ref) => {
    console.log("i am pdfpoolmapppinmg ", props)

    const classes = useStyles();
    const { testId } = useContext(TestContext);
    const { user, providerId, licensePackageObject } = useContext(LoginContext);

    const { data: poolsRaw, isLoading, refetch } = useGetPoolsByTest(testId);
    const deletePool = useDeletePool();
    const increaseSequence = useIncreasePoolSequence();
    const decreaseSequence = useDecreasePoolSequence();

    const [pools, setPools] = useState([]);
    const [alert, setAlert] = useState(null);
    const [open, setOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [severity, setSeverity] = useState("success");

    const [uploading, setUploading] = useState({}); // { [poolId_type]: boolean }
    const [poolEditModal, setPoolEditModal] = React.useState(null);
    const [poolCreateModal, setPoolCreateModal] = React.useState(null);
    const [savingTopic, setSavingTopic] = useState({});

    const [selectedTopics, setSelectedTopics] = useState({});
    // structure: { poolId: topicId }
    const { data: categories } = useGetCategories(true);
    console.log(":categoryb is ", categories)
    const level1Topics = React.useMemo(() => {
        if (!categories) return [];

        return categories.filter(
            x => x.isCategory === false &&
                !x.parent?.toString().startsWith("T") // no parentTopicId
        );
    }, [categories]);
    const showSnackBar = (message, sev) => {
        setSeverity(sev ?? "success");
        setAlertMessage(message);
        setOpen(true);
    };
    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setAlertMessage(null);
        setOpen(false);
    };
    useEffect(() => {
        if (poolsRaw?.length > 0) {
            setPools(poolsRaw);
            const initialTopics = {};

            poolsRaw.forEach((element) => {
                console.log("element ", element);

                initialTopics[element?.poolId] =
                    element?.topics || "";
            });
            console.log("initialTopics ", initialTopics)
            setSelectedTopics(initialTopics);
        } else {
            setTimeout(() => {
                refetch()
            }, 3000);
        }
    }, [poolsRaw]);

    React.useImperativeHandle(ref, () => ({
        isValidated: () => true,
        sendState: () => {
            return sendState();
        },
        state: {

            type: "pdfSection",
        },
    }));
    const sendState = () => {
        return {

            type: "pdfSection",
        };
    };
    const setUploadingFlag = (poolId, type, val) => {
        setUploading((prev) => ({ ...prev, [`${poolId}_${type}`]: val }));
    };


    const addTopicToPool = async (poolId, topicId, oldTopic) => {
        try {
            setSavingTopic(prev => ({
                ...prev,
                [poolId]: true
            }));

            await axios.put(
                `${configUrl.AssessmentServer}/api/pools/addPoolTopic/${poolId}/${topicId}`
            );

            showSnackBar("Topic updated successfully", "success");

        } catch (error) {
            // rollback old value
            setSelectedTopics(prev => ({
                ...prev,
                [poolId]: oldTopic
            }));

            showSnackBar("Failed to update topic", "error");
        } finally {
            setSavingTopic(prev => ({
                ...prev,
                [poolId]: false
            }));
        }
    };
    const updatePool = async (model, testId) => {
        let response = await axios.put(
            `${configUrl.AssessmentServer}/api/pools/${model.poolId}/${testId}`,
            model
        );


        hidePoolEditModal();

        refetch()

        //await getPools();
    };
    const createPool = async (model) => {
        if (model.masteryScore == '') {
            model.masteryScore = 0;
        }
        if (model.passingScore == '') {
            model.passingScore = 0;
        }
        if (model.pointsPerQuestion == '') {
            model.pointsPerQuestion = 0;
        }
        if (model?.negativePointsPerQuestion == '') {
            model.negativePointsPerQuestion = 0;
        }
        if (model.poolId) {
            try {
                await updatePool(model, testId);
                showSnackBar("Updated successfully", 'success');
                return;
            } catch (error) {
                console.log("error", error);
            }
        }

        try {
            let response = await axios.post(`${configUrl.AssessmentServer}/api/pools/${testId}`, model);

            console.log(response?.data);


            let poolId = response?.data?.poolId;

            let resp = await axios.post(
                `${configUrl.AssessmentServer}/api/TestPoolMappings`,
                {
                    testId: testId,
                    poolId: poolId,
                    sequenceId: 0,
                    status: 0,
                    isLocked: false,
                    lockedBy: "",
                    lockedDate: new Date(),
                    duration: null,
                    points: 0,
                    isMandatory: 0,
                    createdBy: user,
                    createdDate: new Date(),
                    updatedBy: user,
                    updatedDate: new Date(),
                }
            );
            hidePoolCreateModal();
            hidePoolEditModal(); // optional safe
            showSnackBar("Saved successfully", "success");
            refetch();
        } catch (error) {
            console.log("error", error?.response?.data?.message);
            if (error?.response) {
                // Code or name already exists
                console.log(error?.response?.data?.message);
                showSnackBar(`${error?.response?.data?.message}`, 'error');
            } else {
                console.error("Error creating pool:", error);
                showSnackBar(`Error creating pool`, 'error');
            }
        } finally {
            hidePoolEditModal();
        }

    };
    const createPoolEditModal = (pool) => {
        let title = "Create Section";

        setPoolEditModal(
            <CustomModal
                modal={true}
                setModal={() => hidePoolEditModal()}
                content={<PdfTestPoolForm createPool={createPool} state={pool} testId={testId} />}
                cancelButtonMessage="cancel"
                okButtonMessage="Create"
                showOk={false}
                onCancelClick={() => hidePoolEditModal()}
                title={title}
                maxWidth="md"
                fullWidth={false}
            />
        );
    };

    const hidePoolEditModal = () => {
        setPoolEditModal(null);
    };
    const createPoolModal = () => {
        let title = "Create Section";
        let packageLimitExceeded = false;
        if (poolsRaw) {
            console.log("sectionData", poolsRaw?.length);
            console.log("packageDetails", licensePackageObject);
            (
                (poolsRaw?.length + 1) > licensePackageObject?.TestSections
                    ?
                    packageLimitExceeded = true &&
                    showSnackBar(`Please upgrade to higher package to create more sections.`, 'warning')

                    : ""
            )

        }
        if (packageLimitExceeded == false) {
            setPoolCreateModal(
                <CustomModal
                    modal={true}
                    setModal={() => hidePoolCreateModal()}
                    content={<PdfTestPoolForm createPool={createPool} testId={testId} />}
                    cancelButtonMessage="cancel"
                    okButtonMessage="Create"
                    showOk={false}
                    onCancelClick={() => hidePoolCreateModal()}
                    title={title}
                    maxWidth="md"
                    fullWidth={false}
                />
            );
        }
    };

    const hidePoolCreateModal = () => {
        setPoolCreateModal(null);
    };

    const uploadQuestionPdf = async (poolId, file, inputRef) => {
        if (!file) return;

        try {
            setUploadingFlag(poolId, "questionPdf", true);

            const formData = new FormData();
            formData.append("file", file);

            const resp = await axios.post(
                `${configUrl.AssessmentServer}/api/Pools/UploadQuestionPdf/${testId}/${poolId}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            showSnackBar(`${resp?.data?.message || "Question PDF uploaded"}`, 'success')

            await refetch();
        } catch (err) {
            showSnackBar(`Question PDF upload failed`, 'error')

        } finally {
            setUploadingFlag(poolId, "questionPdf", false);
            if (inputRef) inputRef.value = "";
        }
    };

    const uploadAnswerPdf = async (poolId, file, inputRef) => {
        if (!file) return;

        try {
            setUploadingFlag(poolId, "answerPdf", true);

            const formData = new FormData();
            formData.append("file", file);

            const resp = await axios.post(
                `${configUrl.AssessmentServer}/api/Pools/UploadTestAnswersPdf/${testId}/${poolId}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            showSnackBar(`${resp?.data?.message || "Answer PDF uploaded"}`, 'success')


            await refetch();
        } catch (err) {
            showSnackBar(`Answer PDF upload failed`, 'error');
        } finally {
            setUploadingFlag(poolId, "answerPdf", false);
            if (inputRef) inputRef.value = "";
        }
    };

    const uploadExcel = async (poolId, file, inputRef) => {
        console.log("file is", poolId, file, inputRef)
        if (!file) return;

        const topicId = selectedTopics[poolId];

        if (!topicId) {
            showSnackBar("Please select a topic before uploading Excel.", "error");
            if (inputRef) inputRef.value = ""; return;
        }

        try {
            setUploadingFlag(poolId, "excel", true);

            const formData = new FormData();
            formData.append("file", file);
            formData.append("providerId", providerId);
            formData.append("poolId", poolId);
            formData.append("topicId", topicId);
            formData.append("createdBy", user);

            const resp = await axios.post(
                `${configUrl.AssessmentServer}/api/Questions/addBulkPdfQuestions`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            showSnackBar(`${resp?.data?.message || "Excel uploaded successfully"}`, "success");
            await refetch();
        } catch (err) {
            showSnackBar(`Excel upload failed`, "error");

        } finally {
            setUploadingFlag(poolId, "excel", false);
            if (inputRef) inputRef.value = "";
        }
    };

    const increaseSeq = (poolId) => {
        increaseSequence.mutate({ testId, poolId });
    };

    const decreaseSeq = (poolId) => {
        decreaseSequence.mutate({ testId, poolId });
    };

    const confirmRemovePool = (poolId) => {
        setAlert(
            <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title={""}
                onConfirm={() => {
                    setAlert(null);
                    deletePool.mutate({ id: poolId, testId });
                }}
                showCancel={true}
                cancelBtnText={"CANCEL"}
                confirmBtnText={"OK"}
            >
                <div style={{ display: "inline-flex", alignItems: "center" }}>
                    <WarningOutlined
                        style={{ marginRight: 8, color: "brown", fontSize: 20 }}
                    />
                    <span>Are you sure you want to delete this section?</span>
                </div>
            </SweetAlert>
        );
    };

    const openSetAnswerPlayer = (section) => {
        let title = "Set Answers"
        console.log('settAnswer clicked-', section)
        setPoolEditModal(
            <CustomModal
                modal={true}
                setModal={() => hidePoolEditModal()}
                content={<TestPlayer config={section} onFinish={() => hidePoolEditModal()} />}
                cancelButtonMessage="cancel"
                okButtonMessage="Create"
                showOk={false}
                onCancelClick={() => hidePoolEditModal()}
                title={title}
                maxWidth="lg"
                fullWidth={true}
            />
        );
    }

    return (
        <GridContainer justify="center">
            {alert}
            <GridItem xs={12} style={{ textAlign: "right", marginBottom: 8 }}>
                <Button
                    disabled={pools?.length >= 10}
                    color="primary"
                    onClick={(e) => {
                        e.preventDefault();
                        //props.addCategory("", nodes.id);
                        createPoolModal();
                    }}                >
                    Create Section
                </Button>
                {pools?.length >= 10 ? (
                    <small style={{ color: "red", marginLeft: 8 }}>
                        You can create only 10 sections for a test
                    </small>
                ) : null}
            </GridItem>

            <GridItem xs={12}>
                {isLoading ? <CircularProgress style={{ marginInline: "45%" }} /> : null}

                <Paper
                    style={{
                        maxHeight: 420,
                        overflow: "auto",
                        boxShadow: "none",
                        padding: 6,
                    }}
                >
                    {isLoading === false &&
                        pools &&
                        pools.map((x, i) => (
                            <div key={x.poolId ?? i} style={{ margin: 6 }}>
                                <Card style={{ marginTop: 4, marginBottom: 4 }}>
                                    <CardBody
                                        style={{
                                            backgroundColor: x.isLocked ? "grey" : "black",
                                            borderRadius: 10,
                                            color: "white",
                                            zIndex: 5,
                                            paddingRight: 12,
                                            paddingLeft: 12,
                                            paddingTop: 6,
                                            paddingBottom: 6,
                                        }}
                                    >
                                        <GridContainer alignItems="center">
                                            {/* CODE */}
                                            <GridItem xs={12} sm={12} md={2}>
                                                <h6 style={{ margin: 0 }}>{x.code}</h6>
                                                <div className={classes.fileMeta}>
                                                    <small style={{ opacity: 0.9 }}>
                                                        {x.poolLanguages?.[0]?.languageCode || ""}
                                                    </small>
                                                </div>
                                            </GridItem>

                                            {/* NAME */}
                                            <GridItem xs={12} sm={12} md={3}>
                                                <h6 style={{ margin: 0 }}>
                                                    {x.poolLanguages?.[0]?.text || x.text}
                                                </h6>
                                            </GridItem>

                                            {/* QUESTION COUNT */}
                                            <GridItem xs={12} sm={12} md={2}>
                                                <small className={classes.smallText}>
                                                    <b>Allow Questions</b> - {x.questionCount ?? 0}
                                                </small>
                                            </GridItem>

                                            {/* TOPICS */}
                                            <GridItem xs={12} sm={12} md={2}>
                                                <small className={classes.smallText}>
                                                    <b>Topic</b>
                                                </small>

                                                <select
                                                    disabled={savingTopic[x.poolId]}
                                                    value={selectedTopics[x.poolId] || ""}
                                                    onChange={(e) => {
                                                        const newTopic = parseInt(e.target.value);
                                                        const oldTopic = selectedTopics[x?.poolId];

                                                        setSelectedTopics(prev => ({
                                                            ...prev,
                                                            [x.poolId]: newTopic
                                                        }));

                                                        addTopicToPool(x.poolId, newTopic, oldTopic);
                                                    }}
                                                    style={{ width: "100%", marginTop: 4 }}
                                                >
                                                    <option value="">Select Topic</option>
                                                    {savingTopic[x.poolId] && (
                                                        <small style={{ color: "#fff" }}>Saving...</small>
                                                    )}
                                                    {level1Topics.map(t => (
                                                        <option key={t.topicId} value={t.topicId}>
                                                            {t.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </GridItem>


                                            {/* ACTIONS */}
                                            <GridItem
                                                xs={12}
                                                sm={12}
                                                md={3}
                                            >
                                                <div className={classes.actionsWrapper}>
                                                    <input
                                                        type="file"
                                                        accept="application/pdf"
                                                        hidden
                                                        disabled={x?.questionPdf == null ? false : true}
                                                        id={`questionPdf-${x.poolId}`}
                                                        onChange={(e) =>
                                                            uploadQuestionPdf(
                                                                x.poolId,
                                                                e.target.files[0],
                                                                e.target
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor={`questionPdf-${x.poolId}`}>
                                                        <Tooltip title="QuestionPdf">
                                                            <Button size="sm" justIcon round disabled={x?.questionPdf == null ? false : true} color="danger" component="span">
                                                                {uploading[`${x.poolId}_questionPdf`] ? (
                                                                    <CircularProgress size={32} />
                                                                ) : (
                                                                    <PictureAsPdf />
                                                                )}
                                                            </Button>
                                                        </Tooltip>
                                                    </label>


                                                    {/* ANSWER PDF */}
                                                    <input
                                                        type="file"
                                                        accept="application/pdf"
                                                        hidden
                                                        disabled={x?.solutionPdf == null ? false : true}
                                                        id={`answerPdf-${x.poolId}`}
                                                        onChange={(e) =>
                                                            uploadAnswerPdf(
                                                                x.poolId,
                                                                e.target.files[0],
                                                                e.target   // ✅ pass input
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor={`answerPdf-${x.poolId}`}>
                                                        <Tooltip title="Solution Pdf">
                                                            <Button size="sm" justIcon round disabled={x?.solutionPdf == null ? false : true} color="google" component="span">
                                                                {uploading[`${x.poolId}_answerPdf`] ? (
                                                                    <CircularProgress size={32} />
                                                                ) : (
                                                                    <PictureAsPdf />
                                                                )}
                                                            </Button>
                                                        </Tooltip>
                                                    </label>


                                                    {/* EXCEL */}
                                                    {/* <input
                                                        type="file"
                                                        accept=".xlsx,.xls"
                                                        hidden
                                                        disabled={x?.assignedQuestionCount > 0 ? true : false}
                                                        id={`excel-${x.poolId}`}
                                                        onChange={(e) =>
                                                            uploadExcel(
                                                                x.poolId,
                                                                e.target.files[0],
                                                                e.target
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor={`excel-${x.poolId}`}>
                                                        <Tooltip title="QuestionExcel">
                                                            <Button size="sm" justIcon round disabled={x?.assignedQuestionCount > 0 ? true : false} color="success" component="span">
                                                                {uploading[`${x.poolId}_excel`] ? (
                                                                    <CircularProgress size={32} />
                                                                ) : (
                                                                    <TableChart />
                                                                )}
                                                            </Button>
                                                        </Tooltip>
                                                    </label> */}

                                                    {/* SET ANSWERS and EDIT */}
                                                    <Tooltip title="Edit pool">
                                                        <Button
                                                            size="sm"
                                                            justIcon
                                                            round
                                                            color="reddit"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                //props.addCategory("", nodes.id);
                                                                createPoolEditModal(x);
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </Button>
                                                    </Tooltip>
                                                    <Tooltip title="Set Answers">
                                                        <Button
                                                            size="sm"
                                                            justIcon
                                                            round
                                                            color="reddit"
                                                            // disabled={pools.length === 1 || deletePool.isLoading}
                                                            disabled={!x?.questionPdf || !selectedTopics?.[x.poolId] || x?.assignedQuestionCount > 0}
                                                            onClick={() => openSetAnswerPlayer(x)}
                                                        >
                                                            <SpellcheckIcon />


                                                        </Button>

                                                    </Tooltip>
                                                    {/* DELETE */}
                                                    <Button
                                                        size="sm"
                                                        justIcon
                                                        round
                                                        color="reddit"
                                                        disabled={pools.length === 1 || deletePool.isLoading}
                                                        onClick={() => confirmRemovePool(x.poolId)}
                                                    >
                                                        <DeleteForever />
                                                    </Button>
                                                </div>
                                            </GridItem>

                                        </GridContainer>
                                    </CardBody>

                                    {/* show uploaded filenames / quick links */}
                                    <div style={{ padding: "8px 16px", background: "#fafafa" }}>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={4}>
                                                <div>
                                                    <strong>Question PDF:</strong>{" "}
                                                    {x.questionPdf ? (
                                                        <a
                                                            href={`${configUrl.AssessmentServer}${x.questionPdf}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {x.questionPdf.split("/").pop()}
                                                        </a>
                                                    ) : (
                                                        <small style={{ color: "#666" }}>Not uploaded</small>
                                                    )}
                                                </div>
                                            </GridItem>

                                            <GridItem xs={12} sm={12} md={4}>
                                                <div>
                                                    <strong>Solution PDF:</strong>{" "}
                                                    {x.solutionPdf ? (
                                                        <a
                                                            href={`${configUrl.AssessmentServer}${x.solutionPdf}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {x.solutionPdf?.split("/").pop()}
                                                        </a>
                                                    ) : (
                                                        <small style={{ color: "#666" }}>Not uploaded</small>
                                                    )}
                                                </div>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={4}>
                                                <div>
                                                    <strong>Total Questions:</strong>{" "}
                                                    {x?.assignedQuestionCount ?? 0}
                                                </div>
                                            </GridItem>
                                            {/* set answer button */}
                                            {/* <GridItem xs={12} sm={12} md={3}>
                                                <Button
                                                    color="primary"
                                                    disabled={x?.assignedQuestionCount > 0 ? true : false}
                                                    onClick={() => openSetAnswerPlayer(x)}
                                                >
                                                    Set Answers
                                                </Button>
                                            </GridItem> */}
                                            {/* <GridItem xs={12} sm={12} md={4}>
                                                <div>
                                                    <strong>Answer Excel:</strong>{" "}
                                                    {x.answerExcel ? (
                                                        <a
                                                            href={`${configUrl.AssessmentServer}${x.answerExcel}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {x.answerExcel.split("/").pop()}
                                                        </a>
                                                    ) : (
                                                        <small style={{ color: "#666" }}>Not uploaded</small>
                                                    )}
                                                </div>
                                            </GridItem> */}
                                        </GridContainer>
                                    </div>
                                </Card>

                                {<Snackbar
                                    open={open}
                                    autoHideDuration={2000}
                                    onClose={handleClose}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                >
                                    <Alert onClose={handleClose} severity={severity}>
                                        {alertMessage}
                                    </Alert>
                                </Snackbar>}
                                {poolEditModal}
                                {poolCreateModal}

                            </div>
                        ))}
                </Paper>
            </GridItem>
        </GridContainer>
    );
});

TestPdfSectionMapping.displayName = "Step3";
export default TestPdfSectionMapping;
